import React from 'react';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

export const Loader = ({ size = 48, tip = '', fullscreen = false }) => {
    return (
        <div
            className={`flex justify-center items-center ${
                fullscreen ? 'h-screen' : 'h-full w-full'
            }`}>
            <Spin
                tip={tip}
                indicator={
                    <LoadingOutlined
                        style={{ fontSize: size, color: '#f46147' }}
                        spin
                    />
                }
            />
        </div>
    );
};
